export default {"src":"/_next/static/media/lead-projectH.289d511c.svg","height":43,"width":505};